<div class="container">
  <div>
    <a ui-dropdown [uiDropdownMenu]="menu">
      Hover me
      <ui-icon uiType="outline:down"></ui-icon>
    </a>
    <ui-dropdown-menu #menu="uiDropdownMenu">
      <ul ui-menu menuSelectable>
        <li ui-menu-item>1st menu item</li>
        <li ui-menu-item>2nd menu item</li>
        <li ui-menu-item>3rd menu item</li>
        <li ui-menu-item menuItemDanger>4th danger item</li>
      </ul>
    </ui-dropdown-menu>
  </div>
  <div>
    <a id="link-dropdown" ui-dropdown uiTrigger="click" [uiDropdownMenu]="menucl">
      Click me
      <ui-icon uiType="outline:down"></ui-icon>
    </a>
    <ui-dropdown-menu #menucl="uiDropdownMenu">
      <ul ui-menu>
        <li ui-menu-item>1st menu item</li>
        <li ui-menu-item>2nd menu item</li>
        <li ui-menu-divider></li>
        <li ui-menu-item menuItemDisabled>disabled menu item</li>
        <li ui-submenu submenuTitle="sub menu">
          <ul>
            <li ui-menu-item>3rd menu item</li>
            <li ui-menu-item>4th menu item</li>
          </ul>
        </li>
        <li ui-submenu submenuDisabled submenuTitle="disabled sub menu">
          <ul>
            <li ui-menu-item>3rd menu item</li>
            <li ui-menu-item>4th menu item</li>
          </ul>
        </li>
      </ul>
    </ui-dropdown-menu>
  </div>
  <div>
    <ng-container *ngFor="let position of listOfPosition">
      <button class="ml-20px" ui-button ui-dropdown [uiDropdownMenu]="menu" [uiPlacement]="position">{{ position }}</button>
      <ui-dropdown-menu #menu="uiDropdownMenu">
        <ul ui-menu>
          <li ui-menu-item>1st menu item length</li>
          <li ui-menu-item>2nd menu item length</li>
          <li ui-menu-item>3rd menu item length</li>
        </ul>
      </ui-dropdown-menu>
    </ng-container>
  </div>
  <br />
  <div>
    <ui-button-group id="btn-group" class="ml-20px">
      <button ui-button (click)="log()">DropDown</button>
      <button ui-button ui-dropdown [uiDropdownMenu]="menu1" uiPlacement="bottomRight">
        <ui-icon uiType="outline:ellipsis"></ui-icon>
      </button>
    </ui-button-group>
    <ui-button-group>
      <button ui-button (click)="log()">DropDown</button>
      <button ui-button ui-dropdown [uiDropdownMenu]="menu2" uiPlacement="bottomRight">
        <ui-icon uiType="outline:user"></ui-icon>
      </button>
    </ui-button-group>
    <ui-button-group>
      <button ui-button disabled>DropDown</button>
      <button ui-button disabled ui-dropdown [uiDropdownMenu]="menu3" uiPlacement="bottomRight">
        <ui-icon uiType="outline:ellipsis"></ui-icon>
      </button>
    </ui-button-group>
    <button ui-button ui-dropdown [uiDropdownMenu]="menu4">
      Button
      <ui-icon uiType="outline:down"></ui-icon>
    </button>
    <ui-dropdown-menu #menu1="uiDropdownMenu">
      <ul ui-menu>
        <li ui-menu-item>menu1 1st menu item</li>
        <li ui-menu-item>menu1 2nd menu item</li>
        <li ui-menu-item>menu1 3rd menu item</li>
      </ul>
    </ui-dropdown-menu>
    <ui-dropdown-menu #menu2="uiDropdownMenu">
      <ul ui-menu>
        <li ui-menu-item>menu2 1st menu item</li>
        <li ui-menu-item>menu2 2nd menu item</li>
        <li ui-menu-item>menu2 3rd menu item</li>
      </ul>
    </ui-dropdown-menu>
    <ui-dropdown-menu #menu3="uiDropdownMenu">
      <ul ui-menu>
        <li ui-menu-item>menu3 1st menu item</li>
        <li ui-menu-item>menu3 2nd menu item</li>
        <li ui-menu-item>menu3 3rd menu item</li>
      </ul>
    </ui-dropdown-menu>
    <ui-dropdown-menu #menu4="uiDropdownMenu">
      <ul ui-menu>
        <li ui-menu-item>menu4 1st menu item</li>
        <li ui-menu-item>menu4 2nd menu item</li>
        <li ui-menu-item>menu4 3rd menu item</li>
      </ul>
    </ui-dropdown-menu>
  </div>
</div>
